import { render } from "./DriverProfile.vue?vue&type=template&id=c65dab24"
import script from "./DriverProfile.vue?vue&type=script&lang=js"
export * from "./DriverProfile.vue?vue&type=script&lang=js"

import "./DriverProfile.vue?vue&type=style&index=0&id=c65dab24&lang=css"
script.render = render

export default script